import Multibonus from './Multibonus';

export default Multibonus;
